import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/Login";
import MemberPage from "./pages/MemberManage";
import SuggestPage from "./pages/SuggestSelect";
import ContentsPage from "./pages/ContentsMonitor";
import SettlementPage from "./pages/SettlementEnd";
import ResultPage from "./pages/Result";
import JoinPage from "./pages/Join";
import Sidebar from "./components/Sidebar";
import HeaderTabs from "./components/HeaderTabs";
import { Flex, Box } from "@chakra-ui/react";
import ProtectedRoute from "./routes/ProtectedRoute";
import { useAuth } from "./context/AuthContext";
import RecruitingDetail from "./pages/SuggestSelect/RecrutingDetail";
import InprogressDetail from "./pages/SuggestSelect/OfferingDetail";
import PendingPaymentDetail from "./pages/SuggestSelect/PendingPaymentDetail";
import ContractedDetail from "./pages/SuggestSelect/ContractedDetail";
import CampaignEdit from "./pages/SuggestSelect/CampaignEdit";
import ContentsDetail from "./pages/ContentsMonitor/ContentsDetail";
import NoticePage from "./pages/Notice";
import NoticeFormPage from "./pages/Notice/NoticeForm";
import NoticeDetailPage from "./pages/Notice/NoticeDetail";
import DmDetailPage from "./pages/DM/DmDetail";
import CpsCommissionsPage from "./pages/CpsCommissions";
import ForgotPasswordPage from "./pages/ForgotPassword";
import ResetPasswordPage from "./pages/ResetPassword";
import AuditLogsPage from "./pages/AuditLogs";

export default function App() {
  const { login, logout } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<LoginPage onLoginSuccess={login} />} />
      <Route path="/join" element={<JoinPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout onLogout={logout} />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

/** 고정 레이아웃 */
function MainLayout({ onLogout }) {
  return (
    <Flex h="100vh" overflow="hidden">
      {/* 사이드바 (고정) */}
      <Sidebar onLogout={onLogout} />

      {/* 오른쪽: 헤더 + 페이지 영역 */}
      <Flex flex="1" flexDir="column" overflow="hidden">
        {/* 헤더 (고정) */}
        <HeaderTabs />

        {/* 페이지 영역만 세로 스크롤 됨 */}
        <Box flex="1" overflowY="auto" overflowX="hidden" p={{ base: "16px", md: "40px" }} bgColor="#F6F7FA">
          <Routes>
            <Route path="member" element={<MemberPage />} />
            <Route path="suggest/*" element={<SuggestPage />} />
            <Route
              path="suggest/recruiting/:id"
              element={<RecruitingDetail />}
            />
            <Route
              path="suggest/pending_payment/:id"
              element={<PendingPaymentDetail />}
            />
            <Route path="suggest/offering/:id" element={<InprogressDetail />} />
            <Route
              path="suggest/contracted/:id"
              element={<ContractedDetail />}
            />
            <Route
              path="suggest/campaign/edit/:id"
              element={<CampaignEdit />}
            />
            <Route path="contents/*" element={<ContentsPage />} />
            <Route path="contents/detail/:id" element={<ContentsDetail />} />
            <Route path="result/*" element={<ResultPage />} />
            <Route path="settlement/*" element={<SettlementPage />} />
            <Route path="cps-commissions" element={<CpsCommissionsPage />} />
            <Route path="cps-settlements" element={<Navigate to="/settlement/wait" replace />} />
            <Route path="audit" element={<AuditLogsPage />} />
            <Route path="/dm" element={<DmDetailPage />} />
            <Route path="/notices" element={<NoticePage />} />
            <Route path="/notices/new" element={<NoticeFormPage />} />
            <Route path="/notices/:id" element={<NoticeDetailPage />} />
            <Route path="/notices/:id/edit" element={<NoticeFormPage />} />
            <Route path="*" element={<Navigate to="member" replace />} />
          </Routes>
        </Box>
      </Flex>
    </Flex>
  );
}
